import axios from 'axios';
import constants from '$lib/constants';

export async function loadSettings() {
	const url = `${constants.API_URL}/settings`;

	const options = {
		url,
		method: 'GET',
		isAuthenticated: true,
	};

	const result = await axios(options);
	return result;
}
